export const SSO_URLS_LIST = [
  '/team',
  '/active-memberships',
  '/team/invite-member',
  '/team/update-permissions',
  '/team/set-account-owner-role/',
  '/team/unset-account-owner-role/',
  '/update-name',
  '/team/resend-invite',
  '/team/delete-member/',
  '/team/allow-sites/',
  '/team/mfa',
  '/service-user/change-email',
  '/service-user/info',
  '/service-user/whitelisted-ips',
  '/service-user/mfa',
  '/service-user/mfa/virtual',
  '/service-user/mfa/email',
  '/create-accountless-subunit',
];
